module.exports = __webpack_public_path__ + "img/home_2.a7b1916a.jpg";